import { InsideLayoutContext } from "layouts/common/inside/InsideLayoutContext";
import { InsideSubHeader } from "layouts/common/inside/InsideSubHeader";
import { MprcLayoutInside } from "layouts/common/inside/MprcLayoutInside";
import { useSession } from "providers/SessionProvider";
import React, { PropsWithChildren, useEffect } from "react";
import { useTranslation } from "react-i18next";

interface IProps extends PropsWithChildren {
    subHeaderAlwaysVisible?: boolean;
    lateralMenu?: React.ReactNode;
    showCloseButtonWhileMenuOpened?: boolean;
}

/**
 * Fornece um contexto de Sessão
 * @param param0
 */
export const InsideLayoutProvider: React.FC<IProps> = ({ lateralMenu, subHeaderAlwaysVisible = false, showCloseButtonWhileMenuOpened, children }) => {
    const [menuOpened, setMenuOpened] = React.useState<boolean>(false);
    const [subHeaderText, setSubHeaderText] = React.useState<string>("");
    const [subHeaderDetail, setSubHeaderDetail] = React.useState<React.ReactNode>(null);
    const session = useSession();
    const { t } = useTranslation("shared");

    const toogleMenu = () => {
        setMenuOpened(!menuOpened);
    };

    const changeSubHeaderText = (value: string) => {
        setSubHeaderText(value);
    };

    useEffect(() => {
        document.title = session.config.tenantUIConfig.title + (subHeaderText ? " - " + subHeaderText : "");
    }, [subHeaderText]);

    return (
        <InsideLayoutContext.Provider
            value={
                {
                    subHeaderText: subHeaderText,
                    subHeaderDetail: subHeaderDetail,
                    menuOpened: menuOpened,
                    closeMenuText: t("App.Layout.CloseMenu"),
                    setMenuOpened: setMenuOpened,
                    showCloseButtonWhileMenuOpened: showCloseButtonWhileMenuOpened ?? false,
                    toogleMenu: toogleMenu,
                    changeSubHeaderText: changeSubHeaderText,
                    changeSubHeaderDetail: setSubHeaderDetail,
                }
            }
        >
            <MprcLayoutInside
                lateralMenuComponent={lateralMenu}
                subHeaderComponent={<InsideSubHeader />}
                subHeaderAlwaysVisible={subHeaderAlwaysVisible}
                menuOpened={menuOpened}
            >
                {children}
            </MprcLayoutInside>

        </InsideLayoutContext.Provider>
    );
};
